const companyMessage = {
  createCompanySuccess: 'Company successfully created.',
  deleteCompanySuccess: 'Company successfully deleted',
  updateCompanySuccess: 'Company successfully updated'
}

export default companyMessage;